
import { ContentType } from '../types';

/**
 * Helper function to detect content type
 */
export const detectContentType = (content: string): ContentType => {
  if (!content) return "unknown";
  
  // Trim the content for more accurate detection
  const trimmedContent = content.trim();
  
  // Enhanced logging for content type detection
  console.log("useContentProcessor: Content type detection data:", {
    hasExportDefault: trimmedContent.includes('export default'),
    hasAssetsPath: trimmedContent.includes('/assets/'),
    hasHtmlExtension: trimmedContent.includes('.html'),
    startsWithLessThan: trimmedContent.startsWith('<'),
    startsWithHash: trimmedContent.startsWith('#'),
    length: trimmedContent.length,
    preview: trimmedContent.substring(0, 50) + "...",
    isProductionBuild: window.location.hostname.includes('lovable.app'),
    hostname: window.location.hostname,
    environment: process.env.NODE_ENV
  });
  
  // Production-specific logging
  if (window.location.hostname.includes('lovable.app')) {
    console.log("PRODUCTION BUILD - Content Analysis:", {
      rawContentLength: content.length,
      rawContentFirst100: content.substring(0, 100),
      rawContentJson: JSON.stringify(content.substring(0, 200)),
      contentIncludesAssets: content.includes('/assets/'),
      contentIncludesExport: content.includes('export default'),
    });
  }
  
  // Special handling for specific articles based on URL
  const currentUrl = window.location.pathname;
  
  // Continue with regular detection
  if (trimmedContent.startsWith('<')) {
    console.log("useContentProcessor: Detected as inline HTML");
    return "html";
  }
  
  if (trimmedContent.startsWith('#')) {
    console.log("useContentProcessor: Detected as Markdown");
    return "markdown";
  }
  
  // If content has JSX or TSX syntax indicators
  if (trimmedContent.includes('import React') || trimmedContent.includes('export default') || 
      trimmedContent.includes('<>') || trimmedContent.includes('</')) {
    if (trimmedContent.includes(':') && trimmedContent.includes('<T>')) {
      console.log("useContentProcessor: Detected as TSX");
      return "tsx";
    } else {
      console.log("useContentProcessor: Detected as JSX");
      return "jsx";
    }
  }
  
  // Plain text fallback
  if (trimmedContent.length > 0) {
    console.log("useContentProcessor: Defaulting to text content");
    return "text";
  }
  
  console.log("useContentProcessor: Unable to determine content type, treating as unknown");
  return "unknown";
};
